import { ReactElement } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Link, Paragraph } from '@digdir/designsystemet-react';
import type { OnboardingGoal } from '../../api/userOnboarding';
import { homeFor } from './gettingStartedView';
import classes from './OnboardingBanner.module.css';

/**
 * At the top of «Opprett team» and «Ny undersøkelse» when they are the first step: where the user
 * is, one tip, and the way back. Without the guidance the screens are as always.
 */
export const OnboardingBanner = ({
  goal,
  step,
  tip,
  withBackLink = true,
}: {
  goal: OnboardingGoal;
  step: 1 | 2;
  tip: string;
  /** Off where the page's own back link already leads to «Kom i gang» */
  withBackLink?: boolean;
}): ReactElement => {
  const { t } = useTranslation();
  return (
    <aside className={classes.banner} aria-label={t('gettingStarted.banner.label')}>
      <div className={classes.text}>
        <span className={classes.step}>{t('gettingStarted.banner.step', { step })}</span>
        <Paragraph data-size="sm">{tip}</Paragraph>
      </div>
      {withBackLink && (
        <Link asChild data-size="sm">
          <RouterLink to={homeFor(goal) ?? '/'}>{t('gettingStarted.banner.back')}</RouterLink>
        </Link>
      )}
    </aside>
  );
};
